module.exports = __webpack_public_path__ + "img/DiscountIcon.3f1b0ae9.svg";